import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import INPUTTEXT from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTTEXT.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
// Model Structure
export const formInputTextAttr = makeAttrStruct([
    ['class']
]);
export const formInputTextData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputTextModel = makeStruct([
    ['attributes', formInputTextAttr],
    ['data', formInputTextData]
]);
// Simplified Model
export function formInputText(label, field, message, buttons) {
    return {
        attributes: formInputTextAttr(),
        data: formInputTextData(label, field, message, buttons)
    };
}
/** Represents an Input[type=Text] for a Form */
export default class FORMINPUTTEXT extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTTEXT(this, model);
    }
}
